import * as React from 'react';
import { RankItem } from '@/fetch.ts';
import defaultAvatar from '@images/default.png';
const Images = Object.keys({
  rankno1: 'rankno1',
  rankno2: 'rankno2',
  rankno3: 'rankno3',
  ranknon: 'ranknon',
}).map((item: any) => require(`./../../assets/images/${item}.png`));

const MasterItem: React.FC<RankItem> = props => (
  <div
    style={
      {
        width: '870px',
        height: '82px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 0px',
      }
    }
  >
    <i
      style={
        props.iRank <= 3 ? {
          width: '34px',
          height: '28px',
          background: `url(${Images[props.iRank - 1].default}) center center no-repeat`,
          backgroundSize: '100% 100%',
        } : {
          width: '24px',
          height: '24px',
          background: `url(${Images[3].default}) center center no-repeat`,
          backgroundSize: '100% 100%',
          color: 'white',
          textAlign: 'center',
          lineHeight: '24px',
          marginLeft: '5px',
          fontSize: '12px',
        }
      }
    >
      {
        props.iRank <= 3 ? '' : props.iRank
      }
    </i>
    <div
      style={
        {
          width: '270px',
          display: 'flex',
          alignItems: 'center',
          marginLeft: '20px',
        }
      }
    >
      <div
        style={
          {
            position: 'relative',
            width: '62px',
            height: '62px',
            borderRadius: '50%',
            marginRight: '8px',
          }
        }
      >
        <img
          style={
            {
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              border: '1px solid black',
            }
          }
          title={props.sNickName}
          src={props.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
        />
      </div>
      <p
        style={
          {
            width: '200px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: '0px',
            fontSize: '14px',
            color: 'white',
            textAlign: 'left',
          }
        }
      >
        {props.sNickName}
      </p>
    </div>
    <p
      style={
        {
          width: '80px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          margin: '0px',
          fontSize: '14px',
          color: 'white',
          textAlign: 'right',
        }
      }
    >{props.lScore}</p>
  </div>
)
const styles = {
  masterItem: {
    width: '870px',
    height: '82px',
    border: '1px solid red',
  },
}

export default MasterItem;